import React, { useEffect, useState } from "react";
import { News } from "../types/News";
import { Link } from "react-router-dom";
import { supabase } from "../lib/supabase";

const AllNewsPage: React.FC = () => {
  const [newsList, setNewsList] = useState<News[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchNews = async () => {
        const { data, error } = await supabase.from('news').select('*');
        if (error) {
            console.error("Haber verisi alınamadı:", error);
        } else {
            setNewsList(data as News[]);
        }
        setLoading(false);
    };
    fetchNews();
  }, []);

  return (
    <div className="min-h-screen bg-gray-100">
      <section className="text-center py-10 bg-[#002744] text-white">
        <h1 className="text-4xl md:text-6xl font-bold mb-4">Tüm Haberler</h1>
        <p className="text-lg max-w-2xl mx-auto opacity-80 md:whitespace-nowrap">
          Ayvalık Marin ile ilgili en güncel haber ve duyurulara buradan ulaşabilirsiniz.
        </p>
      </section>

      <div className="max-w-7xl mx-auto mt-14">
        {/* Yükleniyor */}
        {loading ? (
          <div className="flex justify-center items-center min-h-[300px]">
            <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : newsList.length === 0 ? (
          <div className="flex flex-col items-center justify-center text-center min-h-[300px] py-20">
            <div className="text-6xl mb-4 text-black">:(</div>
            <h2 className="text-2xl font-semibold text-gray-700 mb-2">
              Şu anda hiç haber bulunmamaktadır.
            </h2>
            <p className="text-gray-500 max-w-md">
              Ama eminiz ki çok yakında güzel haberlerle burası dolacak. Takipte kalın!
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {newsList.map((item) => (
              <div
                key={item.id}
                className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition duration-300 hover:scale-[1.01] group flex flex-col"
              >
                <img
                  src={item.ContainerImagePath}
                  alt={item.Title}
                  className="w-full h-56 object-cover group-hover:opacity-90 transition-opacity"
                />
                <div className="p-5 flex flex-col justify-between flex-1">
                  <div className="mb-4">
                    <h3 className="text-xl font-bold text-gray-800 line-clamp-2">
                      {item.Title}
                    </h3>
                    <p className="text-sm text-gray-500">{item.Date}</p>
                    <p className="text-sm text-gray-700 line-clamp-3 mt-2">
                      {item.ShortText}
                    </p>
                  </div>

                  <Link
                    to={`/haber/${item.id}`}
                    className="text-blue-600 hover:underline text-sm font-medium mt-auto"
                  >
                    Haberi Görüntüle →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AllNewsPage;
